export const DEPOT_ALL_REQUEST = "DEPOT_ALL_REQUEST";
export const DEPOT_ALL_SUCCESS = "DEPOT_ALL_SUCCESS";
export const DEPOT_ALL_FAIL = "DEPOT_ALL_FAIL";
export const DEPOT_ALL_RESET = "DEPOT_ALL_RESET";

export const DEPOT_DETAIL_REQUEST = "DEPOT_DETAIL_REQUEST";
export const DEPOT_DETAIL_SUCCESS = "DEPOT_DETAIL_SUCCESS";
export const DEPOT_DETAIL_FAIL = "DEPOT_DETAIL_FAIL";
export const DEPOT_DETAIL_RESET = "DEPOT_DETAIL_RESET";

export const PDF_REQUEST = "PDF_REQUEST";
export const PDF_SUCCESS = "PDF_SUCCESS";
export const PDF_FAIL = "PDF_FAIL";
export const PDF_RESET = "PDF_RESET";

export const PDFMPS_REQUEST = "PDFMPS_REQUEST";
export const PDFMPS_SUCCESS = "PDFMPS_SUCCESS";
export const PDFMPS_FAIL = "PDFMPS_FAIL";
export const PDFMPS_RESET = "PDFMPS_RESET";

export const PDF_DOWNLOAD_REQUEST = "PDF_DOWNLOAD_REQUEST";
export const PDF_DOWNLOAD_SUCCESS = "PDF_DOWNLOAD_SUCCESS";
export const PDF_DOWNLOAD_FAIL = "PDF_DOWNLOAD_FAIL";
export const PDF_DOWNLOAD_RESET = "PDF_DOWNLOAD_RESET";
